import { render, staticRenderFns } from "./IpercTabla.vue?vue&type=template&id=bca9843a&scoped=true"
import script from "./IpercTabla.vue?vue&type=script&lang=js"
export * from "./IpercTabla.vue?vue&type=script&lang=js"
import style0 from "./IpercTabla.vue?vue&type=style&index=0&id=bca9843a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca9843a",
  null
  
)

export default component.exports